import { createHTTPActions } from 'src/app/core/store';
import { IProduct } from '../models/product.model';
import { ISiteProductsUpdatePayload } from '../models/site-products-update-payload.model';
import { IAccountSite } from '../../../../../shared/models/account-site.model';

enum EAccountSitesProductsActions {
  getProducts = '[Account Sites Products] Get Products',
  updateSiteProducts = '[Account Sites Products] Update Site Products',
  updateBulkSitesProducts = '[Account Sites Products] Update Bulk Sites Products',
}

const [getProducts, getProductsSuccess, getProductsError] = createHTTPActions<void, IProduct[], Error>(
  EAccountSitesProductsActions.getProducts,
);

const [updateSiteProducts, updateSiteProductsSuccess, updateSiteProductsError] = createHTTPActions<
  ISiteProductsUpdatePayload,
  IAccountSite,
  Error
>(EAccountSitesProductsActions.updateSiteProducts);

const [updateBulkSitesProducts, updateBulkSitesProductsSuccess, updateBulkSitesProductsError] = createHTTPActions<
  ISiteProductsUpdatePayload[],
  IAccountSite[],
  Error
>(EAccountSitesProductsActions.updateBulkSitesProducts);

export const ACCOUNT_SITES_PRODUCTS_ACTIONS = {
  getProducts,
  getProductsSuccess,
  getProductsError,

  updateSiteProducts,
  updateSiteProductsSuccess,
  updateSiteProductsError,

  updateBulkSitesProducts,
  updateBulkSitesProductsSuccess,
  updateBulkSitesProductsError,
};
